<template>
  <div>
    <loader :loading="loading"></loader>
    <div class="row">
      <div class="col-md-6">
        <card>
          <div>
            <h3 class="card-title mb-0">Instance Summary</h3>
            <p class="category mb-3">
              <span>Created On: {{ displayDate(instanceInfo.createdOn) }}</span><br>
              <span>Modified On: {{ displayDate(instanceInfo.modifiedOn) }}</span><br>
            </p>
            <div>Access Type: {{ instanceInfo.accessTypeName }}</div>
            <div>Sections: {{ instanceInfo.sections.length }}</div>
            <div>Start Date: {{ displayDate(instanceInfo.startDate) }}</div>
            <div>End Date: {{ displayDate(instanceInfo.endDate) }}</div>
          </div>
        </card>
      </div>
      <div class="col-md-6">
        <card>
          <div class="row">
            <div class="col-md-6 mb-3">
              <h3 class="card-title mb-0">Completion</h3>
              <div>Completions: {{ reports.statistics.completionCount }}</div>
              <div>Responses: {{ reports.statistics.responseCount }}</div>
              <div>Completion Rate: {{ completionRate }}%</div>
              <div v-if="reports.statistics.maxRespondents > 0">
                <hr>
                <div>Passwords Requested: {{ reports.statistics.maxRespondents }}</div>
                <div>Overall Completion Rate: {{ overallCompletionRate }}%</div>
              </div>
            </div>
            <div class="col-md-6" v-if="reports.statistics.completionCount > 0">
              <pie-chart
                style="height: 100%"
                :chart-data="getCompletionChartData().chartData"
                :extra-options="getCompletionChartData().extraOptions"
                :height="200">
              </pie-chart>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { mapGetters, mapActions } from 'vuex';
  import { Table, TableColumn } from 'element-ui';
  import PieChart from 'src/components/Charts/PieChart';
  import { formatDateDefault } from 'src/modules/utils';

  export default {
    name: 'Welcome',
    components: {
      Loader,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      PieChart
    },
    data() {
      return {
        trueDisplayValue: 'Yes',
        falseDisplayValue: 'No',
        surveyUrlId: null,
        orgSurvey: {
          hspSurveyId: ''
        },
        loading: true
      };
    },
    computed: {
      surveyUrl() {
        var url = '/surveys/' + this.surveyUrlId;

        return url;
      },
      surveyDisplayUrl() {
        var url = process.env.VUE_APP_URL + this.surveyUrl;
        return url;
      },
      completionRate() {
        return Math.round(this.reports.statistics.completionPercentage * 10000)/100;
      },
      overallCompletionRate() {
        return Math.round(this.reports.statistics.overallCompletionPercentage * 10000)/100;
      },
      ...mapGetters({
        reports: 'getActiveSurveyReports',
        instanceInfo: 'instanceInfo'
      })
    },
    methods: {
      displayDate: formatDateDefault('None'),
      getCompletionChartData() {
        let incompletions = this.reports.statistics.responseCount - this.reports.statistics.completionCount;
        let completions = this.reports.statistics.completionCount;

        return {
          chartData: {
            labels: ['Completions', 'Incomplete'],
            datasets: [
              {
                pointRadius: 0,
                pointHoverRadius: 0,
                backgroundColor: ['#00c09d', '#e2e2e2'],
                borderWidth: 0,
                data: [completions, incompletions]
              }
            ]
          },
          extraOptions: {
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            responsive: true,
            cutoutPercentage: 70,
            tooltips: {
              backgroundColor: '#f5f5f5',
              titleFontColor: '#333',
              bodyFontColor: '#666',
              bodySpacing: 4,
              xPadding: 12,
              mode: 'nearest',
              intersect: 0,
              position: 'nearest'
            },
            scales: {
              yAxes: [
                {
                  display: 0,
                  ticks: {
                    display: false
                  },
                  gridLines: {
                    drawBorder: false,
                    zeroLineColor: 'transparent',
                    color: 'rgba(255,255,255,0.05)'
                  }
                }
              ],
              xAxes: [
                {
                  display: 0,
                  barPercentage: 1.6,
                  gridLines: {
                    drawBorder: false,
                    color: 'rgba(255,255,255,0.1)',
                    zeroLineColor: 'transparent'
                  },
                  ticks: {
                    display: false
                  }
                }
              ]
            }
          }
        };
      },
      ...mapActions([
        'addStatistics'
      ])
    },
    created: function(e) {
      var params = this.$route.params;

      this.surveyUrlId = params.urlId;

      let payload = {
        surveyUrlId: this.surveyUrlId
      }

      this.addStatistics(payload)
        .then(() => {
          this.orgSurvey = this.reports.statistics.orgSurvey;
          this.loading = false;
        });
    }
  };
</script>
<style></style>
